import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface CardStatisticBackgroundImageData {
  label: string;
  value: string;
  image: string;
  class: string;
}
@Component({
  selector: 'app-card-statistic-background-image',
  templateUrl: './card-statistic-background-image.component.html',
  styleUrls: ['./card-statistic-background-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardStatisticBackgroundImageComponent {
  @Input() public data: CardStatisticBackgroundImageData;
}
